var mentions_default = {
  "mentionPalette": "bbku6",
  "mention": "oqMyz",
  "mentionViewer": "IjaZg",
  "mentionSuggestionsEntry": "Pghdz",
  "mentionSuggestionsEntryFocused": "wfdbu",
  "mentionSuggestionsEntryText": "tybWq",
  "mentionSuggestionsEntryAvatar": "l3Ql6",
  "mentionSuggestions": "-Xj4r",
  "cursorDefault": "coo-n",
  "cursorPointer": "CHusZ"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
